/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerandSuppliersbyCityRoutingModule
 * Purpose		: Routing module for CustomerandSuppliersbyCity.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CustomerandSuppliersbyCityListComponent } from './CustomerandSuppliersbyCityList.component';
import { CustomerandSuppliersbyCityDetailsComponent } from './CustomerandSuppliersbyCityDetails.component';

const CustomerandSuppliersbyCityRoutes: Routes = [
	{ path: 'CustomerandSuppliersbyCity',  component: CustomerandSuppliersbyCityListComponent },
	{ path: 'CustomerandSuppliersbyCity/Details/:id', component: CustomerandSuppliersbyCityDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(CustomerandSuppliersbyCityRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class CustomerandSuppliersbyCityRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerandSuppliersbyCity/CustomerandSuppliersbyCity-routing.module.ts